export default "__VITE_ASSET__f011c8d7__"